import $ from 'jquery'
import 'jquery.marquee'
import { gsap, Elastic } from 'gsap'

$('.hero__services').marquee({
  duration: 30000,
  gap: 30,
  delayBeforeStart: 0,
  direction: 'left',
  duplicated: true,
  startVisible: true,
  pauseOnHover: true,
})

const tl = gsap.timeline({ paused: true })

if (document.body.classList.contains('page-template-page-home') || document.body.classList.contains('page-template-page-landing')) {
  tl.from(
    '.hero__service-image',
    {
      y: 20,
      x: 20,
      rotate: -40,
      duration: 3,
      transformOrigin: '30% 80%',
      ease: Elastic.easeOut.config(1, 0.5),
    },
    0
  )
}

const playTl = () => {
  tl.timeScale(1.25).restart()
}

const resetTl = () => {
  tl.progress(0).pause()
}

$('.hero__service-item').on({
  mouseenter(e) {
    const rect = e.target.getBoundingClientRect()
    let x = e.clientX - rect.left
    const r = e.clientX - rect.right

    if (r * -1 <= 75) {
      x = x - 75
    }

    $(this)
      .find('.hero__service-image')
      .css('left', `${x - 15}px`)
    playTl()
  },
  mouseleave: resetTl,
})

const closeVideo = () => {
  const wrapper = $('.hero')
  wrapper.removeClass('hero--video-active')
  $('body').removeClass('video-active')

  const videoWrapper = $('.hero__video-wrapper')
  const iframe = videoWrapper.find('iframe')
  const video = videoWrapper.find('video')
  if (iframe.length) {
    iframe.attr('src', iframe.attr('src'))
  }
  if (video.length) {
    video[0].pause()
    video[0].currentTime = 0
  }

  if (undefined !== window.fp) {
    window.fp.setAllowScrolling(true)
    window.fp.setKeyboardScrolling(true)
  }

  $('.video-active').removeClass('video-active')
  $('.team-video-active').removeClass('team-video-active')
}

$('.hero__play').on('click', () => {
  const wrapper = $('.hero')
  wrapper.addClass('hero--video-active')
  $('body').addClass('video-active')

  const heroWrapper = $('.hero__video-wrapper')
  if (
    !heroWrapper.hasClass('hero__video-wrapper--loaded') &&
    heroWrapper.hasClass('hero__video-wrapper--youtube')
  ) {
    heroWrapper.append(`<iframe src="${heroWrapper.attr('data-src')}">`)
    heroWrapper.addClass('hero__video-wrapper--loaded')
  }

  if (undefined !== window.fp) {
    window.fp.setAllowScrolling(false)
    window.fp.setKeyboardScrolling(false)
  }
})

$('.close-video').on('click', closeVideo)

$(document).keyup(function (e) {
  if (e.key === 'Escape') {
    closeVideo()
  }
})

$('.vn-btn-terms').marquee({
  duration: 30000,
  delayBeforeStart: 0,
  direction: 'left',
  duplicated: true,
  startVisible: true,
  pauseOnHover: true,
})
